module.exports = __webpack_public_path__ + "static/assets/5a3fb8e65a424fdc9eab8a9da45fdc1a.png";